import axios from 'app/api/base';
import { DEFECT_HOT_KEYS } from 'app/utils/constants';
import { updateNextDataURL } from 'app/utils/helpers';
import store from 'store';
import { setReviewData, setReviewDataNextApi } from 'store/reviewData/actions';
import { handleUserClassificationChange } from 'store/reviewData/actions';
import { MANUAL_CLASSIFY } from 'store/reviewData/constants';

import { IS_WAVETEK } from '@/app/constants/env';

export const MNUL_RCLASS_V2_IMAGE_VIEW_KEY = 'manual_reclass_v2_image_view';

export const getGTandAILabel = ({
  filesetData,
  activeImage,
  filesetLabelData,
  filesetLocalLabelData,
}) => {
  const currentImage = filesetData[activeImage[0]];
  const { id: fileId = '' } = currentImage || {};
  const { gt_classifications = {}, model_classifications = [] } =
    filesetLabelData[fileId] || {};
  const { classification_defects: gt_classifications_defects = {} } =
    gt_classifications || {};
  const { defect: gt_label_defect = {} } = gt_classifications_defects[0] || {};
  const local_selected_defect = filesetLocalLabelData[fileId];
  const final_gt_label_defect = local_selected_defect
    ? local_selected_defect
    : gt_label_defect;

  const {
    classification_defects: ai_label_classification_defects = [],
    url: heatmap_url = '',
  } = model_classifications[0] || {};
  const { defect: ai_label_defect = {}, confidence: ai_score } =
    ai_label_classification_defects[0] || {};

  return { final_gt_label_defect, ai_label_defect, ai_score, heatmap_url };
};

export const getDefaultImageViewFromLocalStorage = () => {
  const defaultImageView = localStorage.getItem(MNUL_RCLASS_V2_IMAGE_VIEW_KEY);
  if (defaultImageView) {
    return defaultImageView;
  }

  return IS_WAVETEK ? 'thumbnail' : 'table';
};

export function loadImageList(lastCursorCallRef) {
  const { getState, dispatch } = store;
  const {
    fetchingReviewData,
    next: nextData,
    appliedForAllModelId,
    activeImageMode,
    useAIAssistance,
  } = getState().review;

  if (
    !fetchingReviewData &&
    !!nextData &&
    lastCursorCallRef.current !== nextData
  ) {
    return axios
      .get(`${nextData}`)
      .then(({ data: res }) => {
        lastCursorCallRef.current = nextData;

        dispatch(setReviewDataNextApi(updateNextDataURL(res.next)));

        dispatch(
          setReviewData({
            data: res?.results || [],
            isNewData: false,
            MANUAL_CLASSIFY,
            activeImageMode,
            modelId:
              appliedForAllModelId && useAIAssistance
                ? appliedForAllModelId
                : undefined,
          })
        );
      })
      .catch(_ => {});
  }

  return new Promise(resolve => {
    resolve('');
  });
}

export function fetchHotKeyDefect(e) {
  if (e.repeat) {
    e.preventDefault();
    e.stopPropagation();
    return;
  }

  const avoidableKeys = ['Shift', 'Alt', 'Meta', 'Control'];

  // newShortCutKey will always follow the this sequence Ctrl, Shift, Alt, Arrow, Alphabets
  const newShortCutKey = [];

  if (e.ctrlKey || e.metaKey) {
    newShortCutKey.push('ctrl');
  }
  if (e.shiftKey) {
    newShortCutKey.push('shift');
  }
  if (e.altKey) {
    newShortCutKey.push('alt');
  }
  if (e.key.includes('Arrow')) {
    newShortCutKey.push(e.key.split('Arrow')[1]);
  }
  if (e.key && !avoidableKeys.includes(e.key)) {
    newShortCutKey.push(e.key.toLowerCase());
  }

  return newShortCutKey.join('+').toUpperCase();
}

// eslint-disable-next-line complexity
export function handleImgKeyNavigation(e, onLabelsChange) {
  // prevent hotkey execution when review state object ahs hot keys disabled like for popups
  const disableHotKeys = store.getState().review.disableHotKeys;
  if (disableHotKeys) {
    return;
  }

  // Prevent keydown event from being handled multiple times while held down the key or combo
  if (e.repeat) {
    e.preventDefault();
    e.stopPropagation();
    return;
  }

  const newShortCutKeyString = fetchHotKeyDefect(e);

  if (DEFECT_HOT_KEYS[newShortCutKeyString]) {
    e.preventDefault();
    e.stopPropagation();
    const { getState } = store;
    const { activeImg, data } = getState().review;
    onLabelsChange?.({
      ...DEFECT_HOT_KEYS[newShortCutKeyString],
      defect_id: DEFECT_HOT_KEYS[newShortCutKeyString].id,
      defect_is_killer: DEFECT_HOT_KEYS[newShortCutKeyString].is_killer,
      ids: [...(activeImg.map(i => data[i]['wafer_dot']) || [])],
    });
    return handleUserClassificationChange(
      DEFECT_HOT_KEYS[newShortCutKeyString],
      MANUAL_CLASSIFY
    );
  }
}

export function getImageClassificationType(activeImageMode) {
  const type =
    (!activeImageMode.toLowerCase().includes('un') ? 'un' : '') +
    (activeImageMode.toLowerCase().includes('classified')
      ? 'classified'
      : 'audited');
  return type;
}
